import { render, staticRenderFns } from "./ModalGalleryDelete.vue?vue&type=template&id=352cc3b2"
import script from "./ModalGalleryDelete.vue?vue&type=script&lang=js"
export * from "./ModalGalleryDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports